module.exports = __webpack_public_path__ + "static/img/icon5.78f1241b.png";